import { SHImage, SHStack, SHTypography } from "@components/design-systems";
import React from "react";
import { SHTextOverflowTooltip } from "@components/design-systems/sh-text-overflow-tooltip";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";

export const MSTableManagerCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    return (
      <SHStack
        marginLeft={"-10px"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        gap={1}
      >
        <SHImage
          key={`${cellData.mainHeaderId}-${cellData.subHeaderId}-${cellData.value}`}
          src={cellData.additionalValue ?? ""}
          width={"24px"}
          height={"24px"}
          style={{ objectFit: "contain" }}
        />
        <SHTextOverflowTooltip tooltipContent={cellData.value}>
          <SHTypography variant={"body2"} fontSize={13} lineHeight={1.2} fontWeight={700}>
            {cellData.value}
          </SHTypography>
        </SHTextOverflowTooltip>
      </SHStack>
    );
  },
);
